export default __webpack_public_path__ + "static/ECD_logo-e04dc784bdadb29b4bb6fa4a429953ae.jpg";